import { toast } from "sonner";
import { toastClasses } from "./utils";

class ToastManager {
  private activeToasts = new Set<string>();
  private toastTimeouts = new Map<string, NodeJS.Timeout>();

  showError(message: string, description?: string, duration = 5000) {
    const key = `error-${message}-${description || ""}`;

    if (this.activeToasts.has(key)) {
      return;
    }

    this.activeToasts.add(key);

    toast.error(message, {
      id: key,
      description,
      duration,
      ...toastClasses({ type: "error" }),
    });

    const timeout = setTimeout(() => {
      this.activeToasts.delete(key);
      this.toastTimeouts.delete(key);
    }, duration);

    this.toastTimeouts.set(key, timeout);
  }

  showSuccess(message: string, description?: string, duration?: number) {
    toast.success(message, {
      description,
      duration,
      ...toastClasses({ type: "success" }),
    });
  }

  showInfo(message: string, description?: string) {
    toast.info(message, { description, ...toastClasses({ type: "info" }) });
  }

  dismissAll() {
    this.activeToasts.clear();
    this.toastTimeouts.forEach((timeout) => clearTimeout(timeout));
    this.toastTimeouts.clear();
    toast.dismiss();
  }
}

export const toastManager = new ToastManager();
